import nextGetConfig from 'next/config';

type Config = {
  serverRuntimeConfig: {
    internalApiPassword: string;
    port: string;
    apiEndpointSSR: string;
  };
  publicRuntimeConfig: {
    basePath: string;
    assetPrefix: string;
    origin: string;
    country: string;
    apiEndpoint: string;
    clientID: string;
    clientSecret: string;
    oAuthClientID: string;
    accountUIURL: string;
    versionDigest: string;
    isProduction: boolean;
    defaultPresetID: string;
  };
};

function getConfig() {
  return nextGetConfig() as Config;
}

export type { Config };
export { getConfig };
